import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { SecDashApiClient, secDashApiRef } from './api';

export const secDashPlugin = createPlugin({
  id: 'secdash',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: secDashApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new SecDashApiClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const SecDashPage = secDashPlugin.provide(
  createRoutableExtension({
    name: 'SecDashPage',
    component: () => import('./components/Root').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
